import { createAction } from "@ngrx/store";
import { createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

const ACTION_PREFIX = "[Region]";
export const REGION_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get Success`,
	getAllFail: `${ACTION_PREFIX} Get AllFail`,
};

/**
 * @deprecated [fabric-deprecated] - use fabric RegionService from svc-content instead
 */
export namespace RegionAction {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(ContentServiceCommand.GetAllRegions)" instead
	 */
	export const getAll = createCachedGetAction(createAction(REGION_ACTION_TYPE.getAll));

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(ContentServiceCommand.GetAllRegions)" instead
	 */
	export const getAllSuccess = createGetSuccessAction(
		createAction(REGION_ACTION_TYPE.getAllSuccess, (regions: Record<string, string>) => ({ regions }))
	);

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(ContentServiceCommand.GetAllRegions)" instead
	 */
	export const getAllFail = createAction(REGION_ACTION_TYPE.getAllFail, (error: AppError) => ({ error }));
}
